import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import type { ReactNode } from "react";
import { ValueTile } from "Components/Shared/ValueTile/ValueTile";

type Props = {
  isLoading: boolean;
  value: string;
  title: string;
  explanationHint: ReactNode;
};

export const PayoutValue = ({
  isLoading,
  value,
  title,
  explanationHint,
}: Props) => (
  <ValueTile
    isLoading={isLoading}
    icon={<AccountBalanceWalletIcon />}
    title={title}
    value={value}
    variant="space"
    explanationHint={explanationHint}
  />
);
